'use client';
import { redirect } from 'next/navigation';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.native) {
      window.location.href = '/desktop';
      redirect('/desktop');
      return;
    }
    redirect('/web');
  });

  return null;
}
